import React, { Suspense, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import {
  CycleCompleted,
  CycleDelete,
  CycleInitiate,
  CycleReminder,
  CycleStop,
  GetCycleList,
  GetGoalCycles,
  SaveGoalCycle,
  SendCycleReminder,
  verifyIncludedEmployees,
} from "./PMSService";
const HrAssessment = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [EmpAssessmentList, setEmpAssessmentList] = useState([]);
  const [EmpAssessmentListCount, setEmpAssessmentListCount] = useState([]);
  const toster = useContext(TostMsg);
  const [loading, setLoading] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [showKRACycles, setShowKRACycles] = useState(false);
  // const [reminderMessage, setReminderMessage] = useState("");
  // const [reminderTargets, setReminderTargets] = useState({
  //   employees: true,
  //   managers: false,
  //   skipLevel: false,
  //   normalization: false,
  // });
  const history = useHistory();
  const tabs = ["reminder", "initiate", "complete", "stop", "delete"];
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [reasonForStop, setReasonForStop] = useState("");
  const [empAssessmentSummary, setEmpAssessmentSummary] = useState(null);
  const [showGroupReminderModal, setShowGroupReminderModal] = useState(false);
  const [sendingGroupReminder, setSendingGroupReminder] = useState(false);
  const [reminderSuccessMessage, setReminderSuccessMessage] = useState("");

  const [groupReminderMessage, setGroupReminderMessage] = useState("");

  const [groupReminderOptions, setGroupReminderOptions] = useState({
    SendInitiation: false,
    SendSelfReminder: false,
    SendManagerReminder: false,
    SendSkipReminder: false,
    SendAckReminder: false,
  });

  const [showReminderSuccess, setShowReminderSuccess] = useState(false);
const [goalCycles, setGoalCycles] = useState([]);
const [loadingCycles, setLoadingCycles] = useState(false);
const [creatingCycle, setCreatingCycle] = useState(false);
const [newcycleModal, setNewcycleModal] = useState(false);
const [cycleName, setCycleName] = useState("");
const [cycleError, setCycleError] = useState("");



// const getCycleStatus = (cycle) =>
//   String(
//     cycle?.Status ??
//     cycle?.status ??
//     cycle?.CycleStatus ??
//     cycle?.cycleStatus ??
//     ""
//   ).toLowerCase();

// const isActiveCycle = (cycle) =>
//   getCycleStatus(cycle) === "active";

const fetchGoalCycles = async () => {
  setLoadingCycles(true);
  setCycleError("");

  try {
    const response = await GetGoalCycles();
    const cycles = response?.Data

    setGoalCycles(cycles);
  } catch (error) {
    console.error("Error fetching KRA cycles:", error);

    toster.current.error(
      error?.response?.data?.Message ||
      error?.response?.data?.message ||
      "Unable to load KRA cycles. Please try again."
    );
  } finally {
    setLoadingCycles(false);
  }
};

useEffect(() => {
  fetchGoalCycles();
}, []);

const handleCreateGoalCycle = async (e) => {
  e.preventDefault();

  const name = cycleName.trim();

  if (!name) {
    setCycleError("Please enter a cycle name.");
    return;
  }

  // if (goalCycles.some(isActiveCycle)) {
  //   setCycleError("An Active KRA cycle already exists.");
  //   return;
  // }


  setCycleError("");

  try {

    const params = {

      Name: name,
    
    }
    const response = await SaveGoalCycle(params);

    const result = response?.Data;
  
      if(response?.StatusCode === 2000) {
toster.current.success('KRA cycle created successfully')
      }
else{
  toster.current.error(response.Message);
}

    setNewcycleModal(false);
    setCycleName("");
    setCycleError("");

    await fetchGoalCycles();

    // Use your existing toast component if available.
  
  } catch (error) {
    console.error("Error creating KRA cycle:", error);
  toster.current.error("Unable to create the KRA cycle.");
   
  } finally {
    setNewcycleModal(false);
  }
};

  useEffect(() => {
    getEmpAssessmentPeriodList();
  }, []);

  async function getEmpAssessmentPeriodList() {
    setLoading(true);
    const body = {
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
      StatusFilter: "",
      Guid: "",
    };
    try {
      let response = await GetCycleList(body);
      console.log(response);
      setEmpAssessmentListCount(response?.Data?.TotalCount);
      setEmpAssessmentList(response?.Data?.Items);
      setEmpAssessmentSummary(response?.Data?.Summary);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);

    if (isNaN(d.getTime())) return date;

    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const getDateRange = (item) => {
    const from = formatDate(item.ReviewPeriodFrom);
    const to = formatDate(item.ReviewPeriodTo);

    if (!item.ReviewPeriodFrom && !item.ReviewPeriodTo) {
      return "-";
    }

    return `${from} – ${to}`;
  };

  const openModal = (name) => {
    console.log(name, "modelName----------");
    setActiveModal(name);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const closeGroupReminderModal = () => {
    if (sendingGroupReminder) return;

    setShowGroupReminderModal(false);

    setGroupReminderOptions({
      SendInitiation: false,
      SendSelfReminder: false,
      SendManagerReminder: false,
      SendSkipReminder: false,
      SendAckReminder: false,
    });

    setGroupReminderMessage("");
  };

  const groupReminderOptionsConfig = [
    {
      key: "SendInitiation",
      icon: "🚀",
      title: "Initiation",
      description: "Employees who have not started their appraisal.",
      countKeys: ["PendingInitiation", "PendingInitiations"],
    },
    {
      key: "SendSelfReminder",
      icon: "👤",
      title: "Self Assessment",
      description: "Employees with pending self-assessments.",
      countKeys: ["PendingSelfReviews", "PendingSelfAssessments"],
    },
    {
      key: "SendManagerReminder",
      icon: "👥",
      title: "Manager Review",
      description: "Managers with pending employee reviews.",
      countKeys: ["PendingManagerReviews"],
    },
    {
      key: "SendSkipReminder",
      icon: "↗️",
      title: "Skip-Level Review",
      description: "Skip-level reviewers with pending reviews.",
      countKeys: ["PendingSkipLevelReviews"],
    },
    {
      key: "SendAckReminder",
      icon: "⚖️",
      title: "Normalization",
      description: "Employees pending normalization.",
      countKeys: ["PendingNormalization"],
    },
  ];

  const getValue = (source, keys, defaultValue = 0) => {
    if (!source) return defaultValue;

    for (const key of keys) {
      if (source[key] !== undefined && source[key] !== null) {
        return source[key];
      }
    }

    return defaultValue;
  };

  const toggleGroupReminderOption = (key) => {
    setGroupReminderOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSendGroupReminder = async () => {
    const cycleId = selectedCycle?.Id;

    if (!cycleId) {
      toster?.current?.error("Cycle ID is missing or invalid.");
      return;
    }

    const hasSelection = Object.values(groupReminderOptions).some(Boolean);

    if (!hasSelection) {
      toster?.current?.error("Please select at least one reminder type.");
      return;
    }

    const count = Object.values(groupReminderOptions).filter(
      (value) => value === true,
    ).length;

    try {
      setSendingGroupReminder(true);
      setLoading(true);

      const params = {
        SendInitiation: groupReminderOptions.SendInitiation,
        SendSelfReminder: groupReminderOptions.SendSelfReminder,
        SendManagerReminder: groupReminderOptions.SendManagerReminder,
        SendSkipReminder: groupReminderOptions.SendSkipReminder,
        SendAckReminder: groupReminderOptions.SendAckReminder,
        CustomMessage: groupReminderMessage.trim(),
      };

      console.log("Send Reminder Payload:", {
        cycleId,
        params,
      });

      const response = await SendCycleReminder(cycleId, params);

      console.log("Send Reminder Response:", response);

      const data = response?.Data || response?.data || response || {};

      const totalSent = Number(
        data?.TotalSent ??
          data?.totalSent ??
          data?.SentCount ??
          data?.sentCount ??
          0,
      );

      setShowGroupReminderModal(false);

      // const message =
      //   totalSent > 0
      //     ? `${totalSent} reminder${
      //         totalSent === 1 ? "" : "s"
      //       } sent successfully.`
      //     : "Reminder sent successfully.";

      // setReminderSuccessMessage(message);
      if (response?.StatusCode === 2000) {
        setReminderSuccessMessage(
          `Group reminders have been successfully sent to ${totalSent} recipient${totalSent > 1 ? "s" : ""} across ${count} selected group${count > 1 ? "s" : ""} for ${selectedCycle?.Title}.`,
        );

        setShowReminderSuccess(true);

        toster?.current?.success("Reminder sent successfully");

        // Refresh cycle data
        await getEmpAssessmentPeriodList();
      }

      setLoading(false);
    } catch (error) {
      console.error("Send reminder error:", error);

      const message =
        error?.response?.data?.Message ||
        error?.response?.data?.message ||
        error?.message ||
        "Unable to send reminders.";

      toster?.current?.error(message);
    } finally {
      setSendingGroupReminder(false);
      setLoading(false);
    }
  };

  const confirmInitiate = async () => {
    console.log("Initiate confirmed");
    try {
      setLoading(true);
      const response = await CycleInitiate({ id: selectedCycle?.Id });

      if (response?.StatusCode === 2000) {
        toster.current.success("Cycle initiated successfully.");
        closeModal();
        history.push(`/Assessment/Cycle/Details/${selectedCycle?.Guid}`);
      } else {
        toster.current.error(response?.Message);
      }
      setLoading(false);
    } catch (error) {
      toster.current.error("Failed to initiate the cycle");
      setLoading(false);
    }
  };

  const openGroupReminderModal = (cycle) => {
    setSelectedCycle(cycle);

    setGroupReminderOptions({
      SendInitiation: false,
      SendSelfReminder: false,
      SendManagerReminder: false,
      SendSkipReminder: false,
      SendAckReminder: false,
    });

    setGroupReminderMessage("");
    setReminderSuccessMessage("");

    setShowGroupReminderModal(true);
  };

  const confirmComplete = () => {
    closeModal();
    history.push("/Assessment/Normalization");
  };

  const confirmMarkAsComplete = async () => {
    const params = {
      id: selectedCycle?.Id,
    };
    try {
      setLoading(true);
      const response = await CycleCompleted(params);

      if (response?.StatusCode === 2000) {
        closeModal();
        history.push(`/Assessment/Cycles`);
        getEmpAssessmentPeriodList();
        handleCreateGoalCycle();
        toster.current.success("Cycle marked as complete successfully");
      } else {
        toster.current.error("Failed to mark cycle as complete");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const confirmStop = async () => {
    const params = {
      Reason: reasonForStop,
    };
    try {
      setLoading(true);
      const response = await CycleStop(params, selectedCycle?.Id);

      if (response?.StatusCode === 2000) {
        closeModal();
        history.push(`/Assessment/Cycles`);
        getEmpAssessmentPeriodList();
        toster.current.success("Cycle marked as stopped successfully");
      } else {
        toster.current.error("Failed to mark cycle as stopped");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const confirmDelete = async () => {
    console.log("Delete confirmed");
    setLoading(true);
    const params = {
      id: selectedCycle?.Id,

      Reason: reasonForStop,
    };
    try {
      const response = await CycleDelete(params);

      if (response?.StatusCode === 2000) {
        closeModal();
        getEmpAssessmentPeriodList();
        history.push(`/Assessment/Cycles`);
        toster.current.success("Cycle marked as deleted successfully");
      } else {
        toster.current.error("Failed to mark cycle as deleted");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // const sendReminder = () => {
  //   console.log("Reminder sent", reminderTargets, reminderMessage);
  //   closeModal();
  // };

  const navigateToDetailPage = (guid) => {
    history.push(`/Assessment/Cycle/Details/${guid}`);
  };

  const [verifyEmployees, setverifyEmployees] = useState(0);
  const verifyEmployeesData = async (cycleId) => {
    try {
      setLoading(true);
      const response = await verifyIncludedEmployees(cycleId);

      if (response?.StatusCode === 2000) {
        setverifyEmployees(response?.Data?.Summary?.TotalWithIssues);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const checkForInitiation = async (cycle) => {
    // if(verifyEmployees){
    if (!cycle?.HasQuestions) {
      toster.current.error(
        "Please add some questions in this cycle before initiation",
      );
    } else if (verifyEmployees > 0) {
      toster.current.error(
        `${verifyEmployees} employees have missing data. Required fields missing: First Reviewer, Second Reviewer, and Normalization By`,
      );
    } else {
      openModal("initiate");
    }
    // }
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn" type="button">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <button
            className="menu-item is-flex right-panel-trigger"
            type="button"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </button>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <button
            className="menu-item is-flex right-panel-trigger"
            type="button"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </button>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Assessment Cycles</h2>
              </div>
              <div className="rightside-tabs">
                
                  <button className="btn-og btn-og-third w-auto float-right me-2"   onClick={() => setShowKRACycles(true)}
                  
                  // onClick={() => {setNewcycleModal(true);}}
                  >
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg> */}
                    KRA Cycles
                  </button>

                  
               
                <Link to="/Assessment/AddAssessment">
                  <button className="btn-og btn-og-primary w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                    </svg>
                    New Assessment
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="og-kpi-grid">
              <div className="og-kpi">
                <div className="og-kpi-icon" style={{ background: "#fff5f3" }}>
                  <i className="fa fa-rotate" style={{ color: "#EC4119" }}></i>
                </div>
                <div className="og-kpi-label">Active Cycles</div>
                <div className="og-kpi-value">
                  {empAssessmentSummary?.ActiveCycles ?? 0}
                </div>
                <div className="og-kpi-sub">Currently running</div>
              </div>
              <div className="og-kpi">
                <div className="og-kpi-icon" style={{ background: "#fffbeb" }}>
                  <i
                    className="fa fa-hourglass-half"
                    style={{ color: "#d97706" }}
                  ></i>
                </div>
                <div className="og-kpi-label">Pending Self Reviews</div>
                <div className="og-kpi-value">
                  {empAssessmentSummary?.PendingSelfReviews ?? 0}
                </div>
                <div className="og-kpi-sub">Across active cycles</div>
              </div>
              <div className="og-kpi">
                <div className="og-kpi-icon" style={{ background: "#f3e8ff" }}>
                  <i
                    className="fa fa-clipboard-check"
                    style={{ color: "#7c3aed" }}
                  ></i>
                </div>
                <div className="og-kpi-label">Pending Manager Reviews</div>
                <div className="og-kpi-value">
                  {empAssessmentSummary?.PendingManagerReviews ?? 0}
                </div>
                <div className="og-kpi-sub">Awaiting review</div>
              </div>

              <div className="og-kpi">
                <div className="og-kpi-icon" style={{ background: "#fffbeb" }}>
                  <i
                    className="fa fa-hourglass-half"
                    style={{ color: "#d97706" }}
                  ></i>
                </div>
                <div className="og-kpi-label">Pending Skip level Reviews</div>
                <div className="og-kpi-value">
                  {empAssessmentSummary?.PendingSkipLevelReviews ?? 0}
                </div>
                <div className="og-kpi-sub">Awaiting review</div>
              </div>
              <div className="og-kpi">
                <div className="og-kpi-icon" style={{ background: "#fff7ed" }}>
                  <i
                    className="fa fa-scale-balanced"
                    style={{ color: "#c05621" }}
                  ></i>
                </div>
                <div className="og-kpi-label">Pending Normalization</div>
                <div className="og-kpi-value">
                  {empAssessmentSummary?.PendingNormalization ?? 0}
                </div>
                <div className="og-kpi-sub">Labels to assign</div>
              </div>
              <div className="og-kpi">
                <div className="og-kpi-icon" style={{ background: "#f0fff4" }}>
                  <i className="fa fa-trophy" style={{ color: "#276749" }}></i>
                </div>
                <div className="og-kpi-label">Promotion Recommended</div>
                <div className="og-kpi-value">
                  {empAssessmentSummary?.PromotionRecommended ?? 0}
                </div>
                <div className="og-kpi-sub">This cycle</div>
              </div>
            </div>

            {/* <div className="og-group-label"><i className="fa fa-circle" style={{ color: "#EC4119", fontSize: "8px" }}></i> Open</div>
            <div className="og-cycle-card">
              <div className="og-cycle-card-header">
                <div>
                  <div className="og-cycle-name">FY 26-27 Primary Appraisal</div>
                  <div className="og-cycle-period"><i className="fa fa-calendar-range" style={{ color: "#8492a6", fontSize: "11px" }}></i> Jun 01 – Aug 29 2026 &nbsp;·&nbsp; <span style={{ color: "#EC4119", fontWeight: 600 }}>245 employees</span></div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span className="badge-og badge-normalization">Normalization</span>
                  <button type="button" className="btn-og btn-og-secondary btn-og-sm" onClick={() => openModal('reminder')}><i className="fa fa-bell"></i> Remind</button>
                  <button type="button" className="btn-og btn-og-primary btn-og-sm" onClick={() => history.push('/pms-normalization')}><i className="fa fa-scale-balanced"></i> Normalize</button>
                  <button type="button" className="btn-og btn-og-secondary btn-og-sm" style={{ color: "#276749", borderColor: "#c6f6d5" }} onClick={() => openModal('complete')}><i className="fa fa-flag-checkered"></i> Mark Complete</button>
                  <button type="button" className="btn-og btn-og-secondary btn-og-sm" style={{ color: "#e53e3e", borderColor: "#fed7d7" }} onClick={() => openModal('stop')}><i className="fa fa-stop-circle"></i> Stop</button>
                </div>
              </div>
              <div className="og-timeline">
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Initiated On</div><div className="og-tl-date">Jun 01 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Self Assessment</div><div className="og-tl-date">Jul 15 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Manager Review</div><div className="og-tl-date">Aug 01 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-clock" style={{ color: "#c05621" }}></i> Normalization By</div><div className="og-tl-date" style={{ color: "#c05621", fontWeight: 700 }}>Aug 29 2026</div></div>
              </div>

              <div style={{ marginTop: "12px", padding: "10px 12px", background: "#fff7ed", borderRadius: "8px", display: "flex", alignItems: "center", gap: "14px" }}>
                <i className="fa fa-scale-balanced" style={{ color: "#c05621", fontSize: "16px" }}></i>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "11.5px", marginBottom: "4px" }}><span style={{ color: "#c05621", fontWeight: 600 }}>Normalization Progress</span><span style={{ fontWeight: 700, color: "#1a1a2e" }}>179 / 200 labelled</span></div>
                  <div className="og-progress"><div className="og-progress-bar" style={{ width: "89%", background: "#c05621" }}></div></div>
                </div>
                <div style={{ display: "flex", gap: "6px", fontSize: "11.5px" }}>
                  <span style={{ background: "#fefcbf", color: "#744210", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>12 Stellar</span>
                  <span style={{ background: "#c6f6d5", color: "#276749", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>98 Vital</span>
                  <span style={{ background: "#ebf8ff", color: "#2c5282", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>63 Adequate</span>
                  <span style={{ background: "#fed7d7", color: "#9b2c2c", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>6 Inadequate</span>
                  <span style={{ background: "#f1f3f7", color: "#8492a6", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>21 Pending</span>
                </div>
              </div>
            </div>
            <div className="og-cycle-card">
              <div className="og-cycle-card-header">
                <div>
                  <div className="og-cycle-name">FY 26-27 Secondary Appraisal</div>
                  <div className="og-cycle-period"><i className="fa fa-calendar-range" style={{ color: "#8492a6", fontSize: "11px" }}></i> Aug 14 – Aug 29 2026 &nbsp;·&nbsp; <span style={{ color: "#8492a6" }}>0 employees added</span></div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span className="badge-og badge-created">Created</span>
                  <button type="button" className="btn-og btn-og-outline btn-og-sm" onClick={() => history.push('/pms-cycle-create')}><i className="fa fa-pen"></i> Edit</button>
                  <button type="button" className="btn-og btn-og-primary btn-og-sm" onClick={() => openModal('initiate')}><i className="fa fa-play"></i> Initiate</button>
                  <button type="button" className="btn-og btn-og-secondary btn-og-sm" style={{ color: "#e53e3e" }} onClick={() => openModal('delete')}><i className="fa fa-trash"></i></button>
                </div>
              </div>
              <div className="og-timeline">
                <div className="og-tl-item"><div className="og-tl-label" style={{ color: "#8492a6" }}><i className="fa fa-play-circle"></i> Initiated On</div><div className="og-tl-date" style={{ color: "#8492a6" }}>Aug 14 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label" style={{ color: "#8492a6" }}><i className="fa fa-pen-to-square"></i> Self Assessment By</div><div className="og-tl-date" style={{ color: "#8492a6" }}>Aug 21 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label" style={{ color: "#8492a6" }}><i className="fa fa-user-check"></i> Manager Review By</div><div className="og-tl-date" style={{ color: "#8492a6" }}>Aug 27 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label" style={{ color: "#8492a6" }}><i className="fa fa-flag-checkered"></i> Closure By</div><div className="og-tl-date" style={{ color: "#8492a6" }}>Aug 29 2026</div></div>
              </div>
            </div>
            <div className="og-group-label" style={{ marginTop: "8px" }}><i className="fa fa-circle-check" style={{ color: "#48bb78", fontSize: "8px" }}></i> Completed</div>
            <div className="og-cycle-card" style={{ opacity: ".88" }}>
              <div className="og-cycle-card-header">
                <div>
                  <div className="og-cycle-name">FY 25-26 Annual Review</div>
                  <div className="og-cycle-period"><i className="fa fa-calendar-range" style={{ color: "#8492a6", fontSize: "11px" }}></i> Mar 02 – Mar 31 2026 &nbsp;·&nbsp; 238 employees</div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span className="badge-og badge-completed">Completed</span>
                  <button className="btn-og btn-og-secondary btn-og-sm"><i className="fa fa-download"></i> Export</button>
                </div>
              </div>
              <div className="og-timeline">
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Initiated</div><div className="og-tl-date">Mar 02 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Self Assessment</div><div className="og-tl-date">Mar 13 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Manager Review</div><div className="og-tl-date">Mar 20 2026</div></div>
                <div className="og-tl-item"><div className="og-tl-label"><i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i> Normalized &amp; Closed</div><div className="og-tl-date">Mar 31 2026</div></div>
              </div>

              <div style={{ marginTop: "10px", padding: "8px 12px", background: "#f0fff4", borderRadius: "8px", display: "flex", alignItems: "center", gap: "10px", fontSize: "11.5px" }}>
                <i className="fa fa-circle-check" style={{ color: "#48bb78" }}></i>
                <span style={{ color: "#276749", fontWeight: 600 }}>All 238 employees normalized.</span>
                <span style={{ background: "#fefcbf", color: "#744210", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>18 Stellar</span>
                <span style={{ background: "#c6f6d5", color: "#276749", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>110 Vital</span>
                <span style={{ background: "#ebf8ff", color: "#2c5282", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>98 Adequate</span>
                <span style={{ background: "#fed7d7", color: "#9b2c2c", padding: "2px 8px", borderRadius: "4px", fontWeight: 700 }}>12 Inadequate</span>
              </div>
            </div> */}
          </div>
          <div className="col-xl-12">
                {/* Assessment Cycles */}
                {EmpAssessmentList?.length > 0 ? (
                  <>
                    {/* OPEN / CREATED */}
                    {EmpAssessmentList?.filter(
                      (item) =>
                        item?.StatusName === "Open" ||
                        item?.StatusName === "Created" ||
                        item?.StatusName === "Initiated",
                    ).length > 0 && (
                      <>
                        <div className="og-group-label">
                          <i
                            className="fa fa-circle"
                            style={{
                              color: "#EC4119",
                              fontSize: "8px",
                            }}
                          ></i>{" "}
                          Open
                        </div>

                        {EmpAssessmentList.filter(
                          (item) =>
                            item.StatusName === "Open" ||
                            item.StatusName === "Created" ||
                            item?.StatusName === "Initiated",
                        ).map((item) => {
                          const isCreated = item.StatusName === "Created";
                          const isCompleted = item.StatusName === "Completed";

                          const labelledCount =
                            (item.StellarCount || 0) +
                            (item.VitalCount || 0) +
                            (item.AdequateCount || 0) +
                            (item.InadequateCount || 0);

                          const pendingCount = item.PendingLabelCount || 0;

                          const totalLabels = labelledCount + pendingCount;

                          const progress =
                            totalLabels > 0
                              ? Math.round((labelledCount / totalLabels) * 100)
                              : 0;

                          return (
                            <div
                              className="og-cycle-card"
                              key={item.Id}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                navigateToDetailPage(item.Guid);
                              }}
                            >
                              {/* HEADER */}
                              <div className="og-cycle-card-header">
                                <div>
                                  <div className="og-cycle-name">
                                    {item.Title || "Untitled Assessment"}
                                  </div>

                                  <div className="og-cycle-period">
                                    <i
                                      className="fa fa-calendar-range"
                                      style={{
                                        color: "#8492a6",
                                        fontSize: "11px",
                                      }}
                                    ></i>{" "}
                                    {getDateRange(item)}
                                    &nbsp;·&nbsp;
                                    <span
                                      style={{
                                        color: item.TotalEmployees
                                          ? "#EC4119"
                                          : "#8492a6",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {item.TotalEmployees || 0} employees
                                    </span>
                                  </div>
                                </div>

                                {/* BUTTONS */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    className={`badge-og ${
                                      isCreated
                                        ? "badge-created"
                                        : "badge-normalization"
                                    }`}
                                  >
                                    {item.StatusName}
                                  </span>

                                  {isCreated ? (
                                    <>
                                      <button
                                        type="button"
                                        className="btn-og btn-og-outline btn-og-sm"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          history.push(
                                            `/Assessment/EditAssessment/${item.Guid}`,
                                          );
                                        }}
                                      >
                                        <i className="fa fa-pen"></i> Edit
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-og btn-og-primary btn-og-sm"
                                        onClick={(e) => {
                                          verifyEmployeesData(item?.Id);
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setSelectedCycle(item);

                                          checkForInitiation(item);
                                        }}
                                      >
                                        <i className="fa fa-play"></i> Initiate
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-og btn-og-secondary btn-og-sm"
                                        style={{ color: "#e53e3e" }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setSelectedCycle(item);
                                          openModal("delete");
                                        }}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        type="button"
                                        className="btn-og btn-og-outline btn-og-sm"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          history.push(
                                            `/Assessment/EditAssessment/${item.Guid}`,
                                          );
                                        }}
                                      >
                                        <i className="fa fa-pen"></i> Edit
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-og btn-og-secondary btn-og-sm"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          openGroupReminderModal(item);
                                        }}
                                      >
                                        <i className="fa fa-bell"></i> Remind
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-og btn-og-primary btn-og-sm"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          history.push(
                                            `/Assessment/Normalization/${item.Guid}`,
                                          );
                                        }}
                                      >
                                        <i className="fa fa-scale-balanced"></i>{" "}
                                        Normalize
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-og btn-og-secondary btn-og-sm"
                                        style={{
                                          color: "#276749",
                                          borderColor: "#c6f6d5",
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setSelectedCycle(item);
                                          openModal("complete");
                                        }}
                                      >
                                        <i className="fa fa-flag-checkered"></i>{" "}
                                        Mark Complete
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-og btn-og-secondary btn-og-sm"
                                        style={{
                                          color: "#e53e3e",
                                          borderColor: "#fed7d7",
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setSelectedCycle(item);
                                          openModal("stop");
                                        }}
                                      >
                                        <i className="fa fa-stop-circle"></i>{" "}
                                        Stop
                                      </button>
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* TIMELINE */}
                              <div className="og-timeline">
                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-circle-check"
                                      style={{
                                        color: "#48bb78",
                                      }}
                                    ></i>{" "}
                                    Cycle Started On
                                  </div>

                                  <div className="og-tl-date">
                                    {formatDate(item.CycleStartDate)}
                                  </div>
                                </div>

                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-circle-check"
                                      style={{
                                        color: "#48bb78",
                                      }}
                                    ></i>{" "}
                                    Self Assessment
                                  </div>

                                  <div className="og-tl-date">
                                    {formatDate(item.SelfAssessmentDeadline)}
                                  </div>
                                </div>

                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-circle-check"
                                      style={{
                                        color: "#48bb78",
                                      }}
                                    ></i>{" "}
                                    Manager Review
                                  </div>

                                  <div className="og-tl-date">
                                    {formatDate(item.ManagerReviewDeadline)}
                                  </div>
                                </div>

                                <div className="og-tl-item">
                                  <div className="og-tl-label">
                                    <i
                                      className="fa fa-clock"
                                      style={{
                                        color: "#c05621",
                                      }}
                                    ></i>{" "}
                                    Normalization By
                                  </div>

                                  <div
                                    className="og-tl-date"
                                    style={{
                                      color: "#c05621",
                                      fontWeight: 700,
                                    }}
                                  >
                                    {formatDate(item.NormalizationDeadline)}
                                  </div>
                                </div>
                              </div>

                              {/* NORMALIZATION PROGRESS */}
                              {!isCreated && (
                                <div
                                  style={{
                                    marginTop: "12px",
                                    padding: "10px 12px",
                                    background: "#fff7ed",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "14px",
                                  }}
                                >
                                  <i
                                    className="fa fa-scale-balanced"
                                    style={{
                                      color: "#c05621",
                                      fontSize: "16px",
                                    }}
                                  ></i>

                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        fontSize: "11.5px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#c05621",
                                          fontWeight: 600,
                                        }}
                                      >
                                        Normalization Progress
                                      </span>

                                      <span
                                        style={{
                                          fontWeight: 700,
                                          color: "#1a1a2e",
                                        }}
                                      >
                                        {labelledCount} / {totalLabels} labelled
                                      </span>
                                    </div>

                                    <div className="og-progress">
                                      <div
                                        className="og-progress-bar"
                                        style={{
                                          width: `${progress}%`,
                                          background: "#c05621",
                                        }}
                                      ></div>
                                    </div>
                                  </div>

                                  {/* COUNTS */}
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "6px",
                                      fontSize: "11.5px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        background: "#fefcbf",
                                        color: "#744210",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {item.StellarCount || 0} Stellar
                                    </span>

                                    <span
                                      style={{
                                        background: "#c6f6d5",
                                        color: "#276749",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {item.VitalCount || 0} Vital
                                    </span>

                                    <span
                                      style={{
                                        background: "#ebf8ff",
                                        color: "#2c5282",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {item.AdequateCount || 0} Adequate
                                    </span>

                                    <span
                                      style={{
                                        background: "#fed7d7",
                                        color: "#9b2c2c",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {item.InadequateCount || 0} Inadequate
                                    </span>

                                    <span
                                      style={{
                                        background: "#f1f3f7",
                                        color: "#8492a6",
                                        padding: "2px 8px",
                                        borderRadius: "4px",
                                        fontWeight: 700,
                                      }}
                                    >
                                      {item.PendingLabelCount || 0} Pending
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </>
                    )}

                    {/* COMPLETED */}
                    {EmpAssessmentList.filter(
                      (item) => item.StatusName === "Completed",
                    ).length > 0 && (
                      <>
                        <div
                          className="og-group-label"
                          style={{ marginTop: "8px" }}
                        >
                          <i
                            className="fa fa-circle-check"
                            style={{
                              color: "#48bb78",
                              fontSize: "8px",
                            }}
                          ></i>{" "}
                          Completed
                        </div>

                        {EmpAssessmentList.filter(
                          (item) => item.StatusName === "Completed",
                        ).map((item) => (
                          <div
                            className="og-cycle-card"
                            style={{ opacity: ".88" }}
                            key={item.Id}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              navigateToDetailPage(item.Guid);
                            }}
                          >
                            <div className="og-cycle-card-header">
                              <div>
                                <div className="og-cycle-name">
                                  {item.Title || "Untitled Assessment"}
                                </div>

                                <div className="og-cycle-period">
                                  <i
                                    className="fa fa-calendar-range"
                                    style={{
                                      color: "#8492a6",
                                      fontSize: "11px",
                                    }}
                                  ></i>{" "}
                                  {getDateRange(item)}
                                  &nbsp;·&nbsp;
                                  {item.TotalEmployees || 0} employees
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                <span className="badge-og badge-completed">
                                  {item.StatusName}
                                </span>
                              </div>
                            </div>

                            <div className="og-timeline">
                              <div className="og-tl-item">
                                <div className="og-tl-label">
                                  <i
                                    className="fa fa-circle-check"
                                    style={{
                                      color: "#48bb78",
                                    }}
                                  ></i>{" "}
                                  Initiated
                                </div>

                                <div className="og-tl-date">
                                  {formatDate(item.CycleStartDate)}
                                </div>
                              </div>

                              <div className="og-tl-item">
                                <div className="og-tl-label">
                                  <i
                                    className="fa fa-circle-check"
                                    style={{
                                      color: "#48bb78",
                                    }}
                                  ></i>{" "}
                                  Self Assessment
                                </div>

                                <div className="og-tl-date">
                                  {formatDate(item.SelfAssessmentDeadline)}
                                </div>
                              </div>

                              <div className="og-tl-item">
                                <div className="og-tl-label">
                                  <i
                                    className="fa fa-circle-check"
                                    style={{
                                      color: "#48bb78",
                                    }}
                                  ></i>{" "}
                                  Manager Review
                                </div>

                                <div className="og-tl-date">
                                  {formatDate(item.ManagerReviewDeadline)}
                                </div>
                              </div>

                              <div className="og-tl-item">
                                <div className="og-tl-label">
                                  <i
                                    className="fa fa-circle-check"
                                    style={{
                                      color: "#48bb78",
                                    }}
                                  ></i>{" "}
                                  Normalized & Closed
                                </div>

                                <div className="og-tl-date">
                                  {formatDate(item.CycleEndDate)}
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                marginTop: "10px",
                                padding: "8px 12px",
                                background: "#f0fff4",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                fontSize: "11.5px",
                              }}
                            >
                              <i
                                className="fa fa-circle-check"
                                style={{ color: "#48bb78" }}
                              ></i>

                              <span
                                style={{
                                  color: "#276749",
                                  fontWeight: 600,
                                }}
                              >
                                All {item.TotalEmployees || 0} employees
                                normalized.
                              </span>

                              <span
                                style={{
                                  background: "#fefcbf",
                                  color: "#744210",
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                  fontWeight: 700,
                                }}
                              >
                                {item.StellarCount || 0} Stellar
                              </span>

                              <span
                                style={{
                                  background: "#c6f6d5",
                                  color: "#276749",
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                  fontWeight: 700,
                                }}
                              >
                                {item.VitalCount || 0} Vital
                              </span>

                              <span
                                style={{
                                  background: "#ebf8ff",
                                  color: "#2c5282",
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                  fontWeight: 700,
                                }}
                              >
                                {item.AdequateCount || 0} Adequate
                              </span>

                              <span
                                style={{
                                  background: "#fed7d7",
                                  color: "#9b2c2c",
                                  padding: "2px 8px",
                                  borderRadius: "4px",
                                  fontWeight: 700,
                                }}
                              >
                                {item.InadequateCount || 0} Inadequate
                              </span>
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </>
                ) : (
                  <div className="text-center py-4">
                    No assessment cycles found.
                  </div>
                )}
              </div>

              <div
  className={`kra-sidebar-overlay ${showKRACycles ? "open" : ""}`}
  onClick={() => setShowKRACycles(false)}
>
  <div
    className={`kra-sidebar-panel ${showKRACycles ? "open" : ""}`}
    onClick={(e) => e.stopPropagation()}
  >
    <div className="og-modal-header">
      <div className="og-modal-title">
        <i className="fa fa-list-alt"></i> KRA Cycles
      </div>

      <button
        type="button"
        className="og-modal-close"
        onClick={() => setShowKRACycles(false)}
      >
        <i className="fa fa-times"></i>
      </button>
    </div>

    <div className="kra-sidebar-content">
      
       <div className="kri-cylcle-box">
                <div className="card">
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">KRA Cycles</h4>
                      <p className="mb-0">List of KRA assessment cycles</p>
                    </div>
                    <span className="kra-list-count">
                      {/* {
                        EmpAssessmentList.filter(
                          (item) =>
                            item.KRACycle === true ||
                            item.CycleType === "KRA" ||
                            item.Type === "KRA",
                        ).length
                      } */}
                      <button className="btn-og btn-og-primary btn-sm" onClick={() => setNewcycleModal(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                        </svg>
                      </button>
                    </span>
                  </div>
                  <div className="card-body p-0 ">
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Cycle Name</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Status</th>
                          </tr>
                        </thead>

                        <tbody>
                          {goalCycles.length > 0 ? (
                            goalCycles.map((item) => (
                              <tr key={item.Id}>
                                <td>
                                  <span
                                    className="kra-cycle-name"
                                    title={item.Title || "Untitled Cycle"}
                                  >
                                    {item.Title || "Untitled Cycle"}
                                  </span>
                                </td>

                                <td>{formatDate(item.StartedOn)}</td>

                                <td>{formatDate(item.CompletedOn)}</td>
                                <td>{item?.Status}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="kra-empty-state">
                                No KRA cycles found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
    </div>
  </div>
</div>
          
        </div>
      </div>

      {activeModal && (
        <div
          className={`og-modal-overlay ${tabs.includes(activeModal) ? "open" : ""}`}
          onClick={closeModal}
        >
          <div
            className="og-modal"
            onClick={(event) => event.stopPropagation()}
          >
            {activeModal === "initiate" && (
              <>
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-play-circle"
                      style={{ color: "#EC4119" }}
                    ></i>{" "}
                    Initiate Cycle
                  </div>
                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={closeModal}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div
                  className="modal-body"
                  style={{ textAlign: "center", padding: 8 }}
                >
                  <div style={{ fontSize: 40, marginBottom: 10 }}>🚀</div>
                  <div
                    style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}
                  >
                    {selectedCycle?.Title}
                  </div>
                  <div style={{ fontSize: 13, color: "#8492a6" }}>
                    Initiate for all included employees? Employees will be
                    notified.{" "}
                    <span style={{ color: "#e53e3e" }}>Cannot be undone.</span>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-og btn-og-dark"
                    onClick={confirmInitiate}
                  >
                    <i className="fa fa-play"></i> Confirm &amp; Initiate
                  </button>
                </div>
              </>
            )}
            {activeModal === "complete" && (
              <>
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-flag-checkered"
                      style={{ color: "#276749" }}
                    ></i>{" "}
                    Mark Cycle as Complete
                  </div>
                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={closeModal}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div
                    style={{
                      background: "#fffbeb",
                      border: "1px solid #fbd38d",
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 14,
                      fontSize: 13,
                      color: "#744210",
                    }}
                  >
                    <i
                      className="fa fa-triangle-exclamation"
                      style={{ color: "#d97706" }}
                    ></i>{" "}
                    <strong>
                      {empAssessmentSummary?.PendingNormalization || 0}{" "}
                      employees still have no rating label assigned.
                    </strong>{" "}
                    Completing now will lock the cycle. Unfinished employees
                    will have no final label recorded.
                  </div>
                  <div
                    style={{ fontSize: 13, color: "#8492a6", lineHeight: 1.7 }}
                  >
                    Marking complete will:
                    <br />· Close all pending self-assessments and reviews
                    <br />· Lock the cycle — no further edits possible
                    <br />· Make appraisal letters available to generate
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-og btn-og-primary"
                    onClick={confirmComplete}
                    style={{ background: "#276749" }}
                  >
                    <i className="fa fa-scale-balanced"></i> Finish Normalizing
                    First
                  </button>
                  <button
                    type="button"
                    className="btn-og btn-og-dark"
                    onClick={confirmMarkAsComplete}
                  >
                    <i className="fa fa-flag-checkered"></i> Complete Anyway
                  </button>
                </div>
              </>
            )}
            {activeModal === "stop" && (
              <>
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-stop-circle"
                      style={{ color: "#e53e3e" }}
                    ></i>{" "}
                    Stop Appraisal Cycle
                  </div>
                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={closeModal}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div
                    style={{
                      background: "#fff5f5",
                      border: "1px solid #fed7d7",
                      borderRadius: 8,
                      padding: 6,
                      marginBottom: 9,
                      fontSize: 11.5,
                      color: "#9b2c2c",
                    }}
                  >
                    <i
                      className="fa fa-triangle-exclamation"
                      style={{ color: "#e53e3e" }}
                    ></i>{" "}
                    Stopping this cycle will{" "}
                    <strong>
                      cancel appraisals for all{" "}
                      {empAssessmentSummary?.TotalEmployees || 0} employees
                    </strong>
                    . All data entered so far will be retained but the cycle
                    will be archived. This cannot be undone.
                  </div>
                  <div className="og-form-group" style={{ marginBottom: 0 }}>
                    <label className="og-label">Reason for stopping *</label>
                    <textarea
                      className="og-textarea"
                      placeholder="Explain why this cycle is being stopped..."
                      onChange={(e) => setReasonForStop(e.target.value)}
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-og btn-og-primary"
                    style={{ background: "#e53e3e" }}
                    onClick={confirmStop}
                  >
                    <i className="fa fa-stop-circle"></i> Stop Cycle
                  </button>
                </div>
              </>
            )}
            {activeModal === "delete" && (
              <>
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i className="fa fa-trash" style={{ color: "#e53e3e" }}></i>{" "}
                    Delete Cycle
                  </div>
                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={closeModal}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div
                    style={{ fontSize: 13, color: "#5f6b7c", lineHeight: 1.7 }}
                  >
                    Delete <strong>{selectedCycle?.Title}</strong>? This cycle
                    has not been initiated so no employee data exists. The cycle
                    configuration will be permanently deleted.
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-og btn-og-primary"
                    style={{ background: "#e53e3e" }}
                    onClick={confirmDelete}
                  >
                    <i className="fa fa-trash"></i> Delete Cycle
                  </button>
                </div>
              </>
            )}
 

            
            {/* {activeModal === "reminder" && (
              <>
                <div
                  className={`og-modal-header ${activeModal == "reminder" ? "open" : ""}`}
                >
                  <div className="og-modal-title">
                    <i className="fa fa-bell" style={{ color: "#EC4119" }}></i>{" "}
                    Send Reminder
                  </div>
                  <button
                    type="button"
                    className="og-modal-close"
                    onClick={closeModal}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="og-form-group">
                    <label className="og-label">Send To</label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 13,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={reminderTargets.employees}
                          onChange={() =>
                            setReminderTargets((prev) => ({
                              ...prev,
                              employees: !prev.employees,
                            }))
                          }
                        />{" "}
                        Employees — pending self-appraisal{" "}
                        <span style={{ color: "#EC4119", fontWeight: 600 }}>
                          ({empAssessmentSummary?.PendingSelfReviews || 0})
                        </span>
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 13,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={reminderTargets.managers}
                          onChange={() =>
                            setReminderTargets((prev) => ({
                              ...prev,
                              managers: !prev.managers,
                            }))
                          }
                        />{" "}
                        Managers — pending reviews{" "}
                        <span style={{ color: "#7c3aed", fontWeight: 600 }}>
                          ({empAssessmentSummary?.PendingManagerReviews || 0})
                        </span>
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 13,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={reminderTargets.skipLevel}
                          onChange={() =>
                            setReminderTargets((prev) => ({
                              ...prev,
                              skipLevel: !prev.skipLevel,
                            }))
                          }
                        />{" "}
                        Skip-level — pending reviews{" "}
                        <span style={{ color: "#2b6cb0", fontWeight: 600 }}>
                          ({empAssessmentSummary?.PendingSkipLevelReviews || 0})
                        </span>
                      </label>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          fontSize: 13,
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={reminderTargets.normalization}
                          onChange={() =>
                            setReminderTargets((prev) => ({
                              ...prev,
                              normalization: !prev.normalization,
                            }))
                          }
                        />{" "}
                        Normalization actors — {empAssessmentSummary?.PendingNormalization || 0} pending{" "}
                        <span style={{ color: "#c05621", fontWeight: 600 }}>
                         
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="og-form-group" style={{ marginBottom: 0 }}>
                    <label className="og-label">
                      Custom Message (optional)
                    </label>
                    <textarea
                      className="og-textarea"
                      placeholder="Add a message..."
                      value={reminderMessage}
                      onChange={(e) => setReminderMessage(e.target.value)}
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn-og btn-og-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-og btn-og-primary"
                    onClick={sendReminder}
                  >
                    <i className="fa fa-paper-plane"></i> Send Reminder
                  </button>
                </div>
              </>
            )} */}
          </div>
        </div>
      )}

      {showGroupReminderModal && (
        <div
          className={`og-modal-overlay ${showGroupReminderModal ? "open" : ""}`}
          onClick={closeGroupReminderModal}
        >
          <div className="og-modal" onClick={(e) => e.stopPropagation()}>
            {/* HEADER */}
            <div className="og-modal-header">
              <div className="og-modal-title">
                <i className="fa fa-bell" style={{ color: "#EC4119" }}></i> Send
                Reminder
              </div>

              <button
                type="button"
                className="og-modal-close"
                onClick={closeGroupReminderModal}
                disabled={sendingGroupReminder}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              {/* CYCLE NAME */}
              <div
                style={{
                  marginBottom: 9,
                  padding: "3px 4px",
                  background: "#fff7f3",
                  borderRadius: 8,
                  border: "1px solid #fde0d5",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    color: "#8492a6",
                    marginBottom: 1,
                  }}
                >
                  APPRAISAL CYCLE
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#1a1a2e",
                  }}
                >
                  {selectedCycle?.Title || "Assessment Cycle"}
                </div>
              </div>

              {/* GROUPS */}
              <div className="section-lbl">Notification Groups</div>

              {groupReminderOptionsConfig.map((option) => {
                const count = Number(
                  getValue(empAssessmentSummary, option.countKeys, 0),
                );

                const checked = groupReminderOptions[option.key];

                return (
                  <div
                    key={option.key}
                    className={`chk-item ${checked ? "checked" : ""}`}
                    onClick={() =>
                      !sendingGroupReminder &&
                      toggleGroupReminderOption(option.key)
                    }
                    style={{
                      cursor: sendingGroupReminder ? "not-allowed" : "pointer",
                      opacity: sendingGroupReminder ? 0.7 : 1,
                    }}
                  >
                    <div className={`chk-box ${checked ? "on" : ""}`}>
                      {checked ? "✓" : ""}
                    </div>

                    <div className="chk-content">
                      <div className="chk-title">
                        <span>
                          {option.icon} {option.title}
                        </span>

                        {/* <span className="count-badge count-gray">{count}</span> */}
                      </div>

                      <div className="chk-desc">{option.description}</div>
                    </div>
                  </div>
                );
              })}

              <div className="section-divider"></div>

              {/* CUSTOM MESSAGE */}
              <div className="msg-lbl">
                Custom Message
                <span
                  style={{
                    fontWeight: 400,
                    textTransform: "none",
                    letterSpacing: 0,
                    color: "#8492a6",
                  }}
                >
                  {" "}
                  (Optional)
                </span>
              </div>

              <div className="msg-hint">
                This message will be appended to the standard reminder email.
              </div>

              <textarea
                className="msg-ta"
                value={groupReminderMessage}
                maxLength={500}
                disabled={sendingGroupReminder}
                placeholder="e.g. Please ensure your appraisal is completed before the deadline."
                onChange={(e) => setGroupReminderMessage(e.target.value)}
              />

              <div className="char-count">
                {groupReminderMessage.length} / 500
              </div>

              {/* PREVIEW */}
              <div className="preview-strip">
                <span className="preview-icon">👥</span>

                <span className="preview-text">Selected reminder types:</span>

                <span className="preview-count">
                  {Object.values(groupReminderOptions).filter(Boolean).length}
                </span>
              </div>
            </div>

            {/* FOOTER */}
            <div className="og-modal-footer">
              <button
                type="button"
                className="btn-og btn-og-secondary"
                disabled={sendingGroupReminder}
                onClick={closeGroupReminderModal}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn-og btn-og-primary"
                disabled={
                  sendingGroupReminder ||
                  !Object.values(groupReminderOptions).some(Boolean)
                }
                onClick={handleSendGroupReminder}
              >
                {sendingGroupReminder ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i> Sending...
                  </>
                ) : (
                  <>
                    <i className="fa fa-paper-plane"></i> Send Reminders
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showReminderSuccess && (
        <div
          className={`og-modal-overlay ${showReminderSuccess ? "open" : ""}`}
        >
          <div className="">
            <div className="success-modal">
              <div className="success-icon">✅</div>

              <div className="success-title">Reminder Sent!</div>

              <div className="success-sub">{reminderSuccessMessage}</div>

              <button
                type="button"
                className="btn-done"
                onClick={() => {
                  setShowReminderSuccess(false);
                  setReminderSuccessMessage("");
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}

{newcycleModal && (
  <div
    className="og-modal-overlay open"
    onClick={() => setNewcycleModal(false)}
  >
    <div
      className="og-modal"
    onClick={(e) => e.stopPropagation()}
    >
      <div className="og-modal-header">
        <div className="og-modal-title">
       
          Cycle Details
        </div>

        <button
          type="button"
          className="og-modal-close"
          onClick={() => setNewcycleModal(false)}
        >
          <i className="fa fa-times"></i>
        </button>
      </div>

      <div className="modal-body">
        <div className="form-row form-row-1">
          <div className="fg">
          <label className="form-label">Cycle Name</label>
          <input class="og-input" placeholder="" id="cycleName" onChange={(e) => setCycleName(e.target.value)}/>
          </div>
        </div>

         {/* <div className="fg">
          <label className="form-label">Description</label>
          
            <textarea class="og-textarea" rows="2" placeholder=""></textarea>
          
        </div> */}
      </div>

      <div className="modal-footer">
         <button
          type="button"
          className="btn-og btn-og-secondary"
          onClick={() => setNewcycleModal(false)}
        >
          Close
        </button>
        <button
          type="button"
          className="btn-og btn-og-secondary btn btn-primary"
          onClick={(e) => handleCreateGoalCycle(e)}
        >
          Create
        </button>
       
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default HrAssessment;
